<template>
  <a-modal
    title="选择图标"
    :width="1000"
    :visible="visible"
    @cancel="handleCancel"
  >
    <icon-selector @change="handleIconChange"/>

    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward"type="primary" @click="handleOk">保存</a-button>
    </template>
  </a-modal>

</template>

<script>
import IconSelector from '@/components/IconSelector'
export default {
  name: 'IconModal',
  components: {
    IconSelector
  },
  data () {
    return {
      visible: false,
      iconName: ''
    }
  },
  methods: {
    init () {
      this.iconName = ''
      this.visible = true
    },
    handleIconChange (icon) {
      this.iconName = icon
      this.$message.info(<span>选中图标 <code>{icon}</code></span>)
    },
    handleOk () {
      if (!this.iconName) {
        this.$message.warning('尚未选择任何图标')
        return
      }
      this.$emit('ok', this.iconName)
      this.visible = false
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
